import { useApp } from '@/core/state/appStore'
import { docTitle } from '@/core/lib/docLabels'

const DOCUMENT_ORDER = ['erstgespraech', 'avgs', 'bestaetigung', 'bewilligung', 'vertrag', 'nachweis', 'abschluss']
const orderOf = (name: string) => {
  const index = DOCUMENT_ORDER.indexOf(name)
  return index < 0 ? DOCUMENT_ORDER.length : index
}

export function CoachingDocs({
  coachingId,
  documents,
  gelistet = [],
  sheets,
  sitzungDaten,
  onDocClick,
}: {
  coachingId: string
  documents: string[]

  gelistet?: readonly string[]

  sheets: string[]

  sitzungDaten: Record<string, string>
  onDocClick: (coachingId: string, docName: string, sheet: boolean, e: React.MouseEvent<HTMLElement>) => void
}) {
  const { state } = useApp()
  if (gelistet.length === 0 && documents.length === 0 && sheets.length === 0) {
    return <p className="list-empty">Keine Dokumente</p>
  }
  const rows = [
    ...gelistet.map((name) => ({ name, sheet: false })),
    ...documents
      .filter((name) => !gelistet.includes(name))
      .sort((a, b) => orderOf(a) - orderOf(b))
      .map((name) => ({ name, sheet: false })),
    ...sheets.map((name) => ({ name, sheet: true })),
  ]
  return (
    <div className="list list--cards">
      {rows.map(({ name, sheet }) => {
        const selected = state.selectedCoachingId === coachingId && state.selectedCoachingDocName === name
        return (
          <div
            key={name}
            role="listitem"
            data-testid={`liste-dokument-${name}`}
            tabIndex={0}
            aria-selected={selected || undefined}
            className={selected ? 'list-row is-clickable is-selected' : 'list-row is-clickable'}
            onClick={(e) => onDocClick(coachingId, name, sheet, e)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                e.currentTarget.click()
              }
            }}
          >
            <span className="list-row-title">{docTitle({ name, sheet, sitzungDatum: sitzungDaten[name] ?? '' })}</span>
          </div>
        )
      })}
    </div>
  )
}
